import {TagItem} from "../tagItem";

export class TagReadResponse {

// {
//   "rssi": -66,
//   "rssiPercentage": 0,
//   "time": 1511451609415,
//   "upc": "014671871760",
//   "value": "303400E53C55222D1E74441F"
// }

  public rssi: number;
  public rssiPercentage: number;
  public time: number;
  public upc: string;
  public value: string;
  public sku: string;

  public fromTagItem(tag: TagItem): TagReadResponse {
    this.rssi = -90;
    this.rssiPercentage = 0;
    this.time = Date.now();
    this.upc = tag.upc;
    this.value = tag.epc;
    return this;
  }

  fromLastCycleCountReportResponse(tag: any): TagReadResponse {
    this.rssi = -90;
    this.rssiPercentage = 0;
    this.time = Date.now();
    this.value = tag[0];
    this.sku = tag[1];
    return this
  }
}



// WEBPACK FOOTER //
// ./src/models/reader-model/tagReadResponse.ts